export default __webpack_public_path__ + "static/media/all-temples-simhachalam-card-img.ad812ac5.png";